import React, { Component } from "react";
import { Layout, Breadcrumb, Button, PageHeader } from "antd";
import { RightOutlined } from "@ant-design/icons";
import SurgicalProcedureTable from "./SurgicalProcedureTable";
import SurgicalProcedureForm from "./SurgicalProcedureForm";

import { getOne as getSurgicalProcedure } from "../../api/SurgicalProcedure";

const { Content } = Layout;

class SurgicalProcedures extends Component {

  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props);

    this.state = {
      showSurgicalProcedureForm: false,
      surgicalProcedureToEdit: null,
    };

    this.surgicalProcedureTable = React.createRef();
  }

  /**
   *
   */
  onCreatedHandler = () => {
    this.surgicalProcedureTable.current.reload();

    this.setState({
      showSurgicalProcedureForm: false,
    });
  };

  /**
   *
   */
  addSurgicalProcedure = () => {
    this.setState({
      showSurgicalProcedureForm: true,
      surgicalProcedureToEdit: null
    });
  };

  /**
   *
   */
  closeSurgicalProcedureForm = () => {
    this.setState({
      showSurgicalProcedureForm: false,
    });
  };

  onSurgicalProcedureEditHandler = async (userId) => {
    getSurgicalProcedure(userId)
      .then((data) => {
        this.setState({
          showSurgicalProcedureForm: true,
          surgicalProcedureToEdit: data,
        });
      });
  };

  render() {
    return (
      <Content
        style={{
          margin: "24px 16px",
          padding: 24,
          minHeight: 280,
        }}
      >
        <Breadcrumb
          style={{ padding: 24 }}
          separator={<RightOutlined style={{ fontSize: "75%" }} />}
        >
          <Breadcrumb.Item>
            <a href="/home">Accueil</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Paramétrage</Breadcrumb.Item>
          <Breadcrumb.Item>Procédures</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          ghost={false}
          title="Procédures"
          extra={[
            <Button
              key="add"
              type="primary"
              size="large"
              onClick={this.addSurgicalProcedure}
            >
              Nouvelle procédure
            </Button>,
          ]}
        />
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          <SurgicalProcedureTable ref={this.surgicalProcedureTable} onEdit={this.onSurgicalProcedureEditHandler} />
          <SurgicalProcedureForm
            visible={this.state.showSurgicalProcedureForm}
            surgicalProcedure={this.state.surgicalProcedureToEdit}
            onCreated={this.onCreatedHandler}
            onClose={this.closeSurgicalProcedureForm}
          />
        </div>
      </Content>
    );
  }
}

export default SurgicalProcedures;